import { ListCardType } from '@/components/common/ListCard'
import { Country, GlobalOffer, ImageBlock, Offer, ThingsToDo, Work } from '@/payload-types'

export type BasePath =
  | '/offers'
  | '/offers/hotel'
  | '/things-to-do'
  | '/vacancies'
  | '/press'
  | '/hotels'
  | '/offers'

function isCountry(item: any): item is Country {
  return item && 'campaignTitle' in item // 👈 adjust this to a unique key in your Country type
}

type ItemType = {
  id: number
  title: string
  description?: string | null | undefined
  image?: ImageBlock | undefined
  slug?: string | null | undefined
  _status?: ('draft' | 'published') | null | undefined
}

export function transformToListCards(
  // items: (number | Offer | ThingsToDo | Work | Country | GlobalOffer)[] | undefined,
  items: (number | ThingsToDo | ItemType)[] | undefined,
  basePath: BasePath,
): ListCardType[] {
  if (!items || items.length === 0) return []

  if (items.length === 0) return []

  return items
    .map((item) => {
      if (typeof item === 'number') return null
      if (
        item._status === 'draft' ||
        item.slug === null ||
        item.slug === undefined ||
        item.slug === ''
      )
        return null

      let title = item.title
      if (isCountry(item) && item?.campaignTitle) {
        title = item.campaignTitle
      }
      return {
        title: title,
        description: item.description,
        image: item.image,
        link: { pathname: `${basePath}/[slug]` as const, params: { slug: item.slug as string } },
      }
    })
    .filter((offer) => offer !== null)
}
